import type { PriceableItemOrigin } from "elephant-web/gql";

export function linkToPriceListHome() {
  return "/price-list";
}

export function linkToCreatePriceList() {
  return `${linkToPriceListHome()}/create`;
}

export function linkToPriceList(priceListId = ":id") {
  return `${linkToPriceListHome()}/${priceListId}`;
}

export function linkToAddPrices(
  priceListId = ":id",
  queryParams?: { tariffId: string; origin: PriceableItemOrigin },
) {
  const baseUrl = `${linkToPriceList(priceListId)}/add-prices`;
  if (!queryParams) {
    return baseUrl;
  }
  const queryStr = new URLSearchParams(queryParams).toString();
  return `${linkToPriceList(priceListId)}/add-prices?${queryStr}`;
}

export function linkToCreateCustomItems(priceListId = ":id") {
  return `${linkToPriceList(priceListId)}/create-custom-items`;
}

export function linkToBulkImport(priceListId = ":id") {
  return `${linkToPriceList(priceListId)}/bulk-import`;
}
